import { Button, Collapse, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Link as Scroll } from "react-scroll";
import Services from "./Services";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    fontFamily: "Nunito",
  },
  container: { textAlign: "center" },
  title: { color: "#fff", fontSize: "2.5rem" },
  title2: {
    color: "#fff",
    fontSize: "1rem",
  },
  contactUsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  contactUsButton: {
    color: "#fff",
    margin: theme.spacing(2),
    fontFamily: "Nunito",
  },
  goDown: {
    color: "#fff",
    fontSize: "4rem",
  },
}));

const HomePage = (props) => {
  const { setCurrPage } = props;
  const classes = useStyles();

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(true);
  }, []);

  return (
    <>
      <div className={classes.root} id="header">
        <Collapse
          in={checked}
          {...(checked ? { timeout: 1000 } : {})}
          collapsedHeight={50}
        >
          <div className={classes.container}>
            <h1 className={classes.title}>Veteran and Woman Owned</h1>
            <h1 className={classes.title2}>
              Serving the residents of St. Augustine and the surrounding area
            </h1>
            <h1 className={classes.title2}>
              Call today or contact us for a free estimate.
            </h1>
            <div className={classes.contactUsContainer}>
              <h1 className={classes.title2}>(908) 544-7160</h1>
              <Button
                className={classes.contactUsButton}
                variant="contained"
                color="secondary"
                component={Link}
                to={"/contact-us"}
                onClick={() => setCurrPage("Contact Us")}
              >
                Contact Us
              </Button>
            </div>

            <Scroll to="services" smooth={true}>
              <IconButton>
                <ExpandMoreIcon className={classes.goDown} />
              </IconButton>
            </Scroll>
          </div>
        </Collapse>
      </div>

      <Services setCurrPage={setCurrPage} />
    </>
  );
};
export default HomePage;
